<template>
    <div class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Sales order number") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrderGroup.sales_order_number ? activeWorkOrderGroup.sales_order_number : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Estimated production time") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrderGroup.estimated_time ? activeWorkOrderGroup.estimated_time : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Production order number") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrderGroup.production_order_number ? activeWorkOrderGroup.production_order_number : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Production date") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrderGroup.production_date ? activeWorkOrderGroup.production_date : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Production time") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrderGroup.production_time ? activeWorkOrderGroup.production_time : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Planned quantity") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrderGroup.planned_quantity ? activeWorkOrderGroup.planned_quantity : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Product code") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrderGroup.product_code ? activeWorkOrderGroup.product_code : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Product name") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrderGroup.product_name ? activeWorkOrderGroup.product_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Product EAN") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeWorkOrderGroup.product_ean ? activeWorkOrderGroup.product_ean : "-" }}
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Store from "@/store";
export default {
    name: "group-info-tab",

    data() {
        return {
            countryName: null
        };
    },
    async mounted() {},
    computed: {
        ...mapState("WorkOrderStore", ["activeWorkOrderGroup"])
    },
    methods: {}
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}

.dot {
    margin-right: 10px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}
</style>
